import { env } from '../env';
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export default function HeaderBar({ title }) {
    document.title = env.REACT_APP_TITLE + " - " + title;
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
                  <Button color="titleButton">{env.REACT_APP_TITLE}</Button>
          <Typography
            align="center"
            variant="h6"
            component="div"
                      sx={{ flexGrow: 1 }}
                  >{title}
                      </Typography>
                  <Button>{env.REACT_APP_TITLE}</Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
